import { render, staticRenderFns } from "./SocialIcons.vue?vue&type=template&id=4c69817a&scoped=true&"
import script from "./SocialIcons.vue?vue&type=script&lang=js&"
export * from "./SocialIcons.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/SocialIcons/SocialIcons.less?vue&type=style&index=0&id=4c69817a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c69817a",
  null
  
)

export default component.exports